import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Layout from 'components/Layout'
import CategoriesComponent from 'components/Categories'
import ListFilters from 'components/Categories/ListFilters'
import Loader from 'components/Loader'

import { fetchFeatureFlags } from 'store/FeatureFlags/actions'
import { getIsCategoriesLoading } from 'store/Categories/selectors'
import { loadCategories } from 'store/Categories/actions'
import { setCategoriesSortingMode } from 'store/AppState/actions'
import {
  loadGlobalItems,
  clearItemsIndexes,
} from 'store/Items/actions'
import { getIsItemsLoading } from 'store/Items/selector'
import { getCurrentVenueUuid } from 'store/Venues/selector'
import { getIsLoadingFeatureFlags } from 'store/FeatureFlags/selectors'
import { getOrgName } from 'store/AppState/selector'
import { CATEGORY_BANNER_SETTINGS } from 'resources'

const Categories = () => {
  const dispatch = useDispatch()

  const currentVenueUuid = useSelector(getCurrentVenueUuid)
  const orgName = useSelector(getOrgName)

  const isCategoriesLoading = useSelector(getIsCategoriesLoading)
  const isItemsLoading = useSelector(getIsItemsLoading)
  const isLoadingFeatureFlags = useSelector(getIsLoadingFeatureFlags)

  const isLoading =
    isCategoriesLoading || isItemsLoading || isLoadingFeatureFlags

  useEffect(() => {
    dispatch(fetchFeatureFlags(currentVenueUuid, orgName))
    dispatch(loadCategories(currentVenueUuid))
    dispatch(loadGlobalItems(currentVenueUuid))

    return () => {
      dispatch(clearItemsIndexes())
      dispatch(setCategoriesSortingMode(false))
    }
    // eslint-disable-next-line
  }, [currentVenueUuid])

  if (isLoading) {
    return <Loader />
  } else {
    return (
      <>
        <Layout
          isSidebar
          title="Categories"
          navbarContent={<ListFilters />}
          mainContent={<CategoriesComponent />}
          bannerSettings={CATEGORY_BANNER_SETTINGS}
        />
      </>
    )
  }
}

export default Categories
